<template>
  <a-tag
    class="my-2 w-100"
    :color="bgColor"
    :key="key"
    :style="{ color: textColor, border: `1px solid ${borderColor}` }"
  >
    <a-checkbox class="pr-2" :defaultChecked="arg.show" @change="onCheckboxChange" />
    {{arg.paramDesc}}
  </a-tag>
</template>

<script>
export default {
  name: 'ArgTag',
  props: {
    arg: {
      type: Object,
      default: () => ({ id: '', show: true }),
    },
  },
  computed: {
    key() {
      return Date.now()
    },
    bgColor() {
      return this.arg.show ? '#e6f7ff' : '#F5F5F5'
    },
    textColor() {
      return this.arg.show ? '#1890ff' : '#999'
    },
    borderColor() {
      return this.arg.show ? '#91d5ff' : '#e8e8e8'
    },
  },
  methods: {
    onCheckboxChange(e) {
      this.$emit('change', e.target.checked)
    },
  },
}
</script>
